<div class="gradient gradient--{{ codename }}"></div>
<rt-box variant="vertical">
  <div layout-horizontal layout-space-between layout-align-items-center>
    <div layout-vertical>
      <div layout-horizontal layout-align-items-center>
        <span text-bold text-darkest>
          {{
            'app.pricing.product_order.summary.heading'
              | translate: { planName: product | rtProductName, companyName: companyName }
          }}
        </span>
        @if (product.custom) {
          <rt-icon
            name="info-outline"
            [rtTooltip]="
              'app.pricing.product_order.customized_x_plan_tooltip'
                | translate
                  : {
                      planName: codename | rtProductName: { short: true } | titlecase
                    }
            "
            margin-left-small-xx
            class="primary-on-hover"
          ></rt-icon>
        }
        <rt-button
          [routerLink]="['../select-product']"
          margin-lr-small
          variant="outline"
          size="small"
        >
          {{ 'app.pricing.product_order.change_plan' | translate }}
        </rt-button>
      </div>
      <div layout-horizontal>
        @if (slots) {
          {{ 'app.pricing.job_slots_count' | translate: { count: slots } }}
          <rt-divider variant="dot"></rt-divider>
        }
        {{ humanReadableDetailsInterval }}
        <rt-divider variant="dot"></rt-divider>
        {{ currencyCode }} {{ product.currency }}
      </div>
    </div>
    <div layout-vertical layout-align-self-start>
      <div layout layout-justify-flex-end>
        <span class="interval" white-space-no-wrap layout-align-self-end>{{
          humanReadableSummaryInterval
        }}</span
        >&nbsp;&nbsp;<span class="cost">{{
          estimatedCostWithTaxes ?? totalCost | currency: product.currency : 'symbol' : '1.0-0'
        }}</span>
      </div>
      @if (showTaxInfo) {
        <span layout layout-align-self-end>
          {{ taxInformation || ('app.pricing.product_order.taxes_not_included' | translate) }}
          @if (taxTooltip) {
            <rt-icon-help
              margin-left-small-xx
              [rtTooltip]="taxTooltip"
              [rtTooltipPosition]="'below'"
              [rtTooltipHasTextAlignCenter]="true"
            ></rt-icon-help>
          }
        </span>
      }
    </div>
  </div>
</rt-box>
